module.exports = {"420882001":"新市街道","420882002":"永兴街道","420882003":"温泉街道","420882102":"曹武镇","420882103":"罗店镇","420882104":"宋河镇","420882105":"坪坝镇","420882106":"三阳镇","420882107":"绿林镇","420882108":"杨集镇","420882109":"孙桥镇","420882110":"石龙镇","420882111":"永漋镇","420882112":"雁门口镇","420882113":"钱场镇","420882450":"太子山","420882451":"罗汉寺","420882452":"长滩","420882453":"何集","420882455":"易家岭"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420882.json
// module id = 1878
// module chunks = 0